import { maestroApiCall } from '@michelin/central-provider';
import { SelectOption } from '@michelin/select-options-provider';
import { Dictionary } from 'lodash';
import { ErrorType } from 'types/APIResponse';
import { vehicleSaveAPIType } from 'types/APITypes';
import { VehicleType } from 'types/UFOTypes';

/* ******************** */
/* ******************** */
/* Fetch and Parse Data */
/* ******************** */
/* ******************** */

export function buildOptionsAndValuesFromObject(data: any): SelectOption[] {
  return data.map((elem: any) => ({
    label: elem.name,
    value: elem.id,
    order: elem.id,
  }));
}

export function buildOptionsAndValuesFromArray(data: any): SelectOption[] {
  return data.map((option: number, key: number) => ({
    label: option.toString(),
    value: option.toString(),
    order: (key + 1).toString(),
  }));
}

export function buildOptionsAndValuesFromSpeedRatings(data: any): SelectOption[] {
  return data.map((elem: any) => ({
    label: elem.speed_rating.toString(),
    value: elem.id.toString(),
    order: elem.id,
  }));
}

export async function saveVehicleAPICall(
  data: VehicleType,
  fleet_id: string,
  dealer_id: string,
  vehicle_id?: string,
) {
  const apiType = vehicleSaveAPIType(fleet_id, dealer_id, vehicle_id);

  try {
    const requestData: Dictionary<any> = {
      color: data.color || null,
      fleet_id_no: data.fleet_id_no,
      license_plate: data.license_plate,
      license_state_abbreviation: data.license_state_abbreviation,
      make_id: data.make_id,
      model_id: data.model_id,
      option_id: data.option_id,
      tire_size_id: data.tire_size_id === 'custom' ? null : data.tire_size_id,
      custom_tire_size_id: !data.tire_size_id || data.tire_size_id === 'custom' ? data.custom_tire_size_id : null,
      type: data.type,
      vin: data.vin,
      // eslint-disable-next-line radix
      year: Number(data.year),
    };

    const responseData = await maestroApiCall(apiType, requestData);
    return { body: responseData, status: 200, aborted: false };
  } catch (e: unknown) {
    try {
      const errorString = String(e);
      const errorJSON = JSON.parse(errorString.slice(errorString.indexOf('{'), errorString.lastIndexOf('}') + 1));
      const error = errorJSON as ErrorType;
      return { body: { error: error.message ?? 'Error saving vehicle, please try again'}, status: 500, aborted: error.code === 20 };
    } catch (parsingError: unknown) {
      // JSON parse error, returning string
      return { body: { error: 'Error saving vehicle, please try again'}, status: 500, aborted: false };
    }
  }
}
